import { Button, Layout, theme, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { IoAddSharp } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import routes from "../../../engine/routes";
import { getLogs } from "../Slices/Logs.slice";
import CustomTable from "../../../shared/components/CustomTable";
import { columnsLogList, inputsLogsList } from "./LogsListForms";
import { AlignCenterEnd } from "../../../shared/components/AlignCenterEnd/AlignCenterEnd";
import { objectToUrlParams } from "../../../utils/helpersFunction";
import { defaultSorterByTab } from "../../Prestations/PrestationsList/Prestations.list.constants";
import { getPrestations } from "../../Prestations/Slices/Prestations.slice";

const { Content, Sider, Header, Footer } = Layout;

export function LogsList(props) {
  const { logs, loading, totals } = useSelector(state => state.logs);

  const searcher = localStorage.getItem("logsSearcher");

  const searcherObj = JSON.parse(searcher);

  const formRef = useRef(null);

  const dispatch = useDispatch();

  const location = useLocation();

  const query = new URLSearchParams(location.search);

  const entityId = query.get("entityId");

  const [searchState, setSearchState] = React.useState(
    { ...searcherObj?.searchState, entityId } || { entityId },
  );

  const defaultPagination = {
    totalPages: 0,
    currentPage: 1,
    pageSize: 100,
    sorter: {
      key: "createdAt",
      order: "ascend",
    },
  };

  const [pagination, setPagination] = React.useState(
    searcherObj?.pagination || defaultPagination,
  );

  const dispatchActionLogs = () => {
    const search = objectToUrlParams({
      ...searchState,
      ...pagination,
    });
    console.log(search);
    dispatch(getLogs({ search }));
  };

  useEffect(() => {
    dispatchActionLogs();

    const searcher = {
      searchState,
      pagination,
    };

    localStorage.setItem("logsSearcher", JSON.stringify(searcher));
  }, [searchState, pagination]);

  const handleSubmit = data => {
    setSearchState(data);
  };

  // const onValuesChange = (changedValues, allValues) => {
  //   Object.keys(changedValues).map(changed => {
  //     switch (changed) {
  //       case "entityId":
  //         setSearch(allValues);
  //         break;
  //     }
  //   });
  // };

  // const searchFilterData = () =>
  //   institutions.filter(institution => {
  //     const {
  //       name = "",
  //       interventionLocation = "",
  //       tags = [],
  //       type = "",
  //       mainType = "",
  //       secondName = "",
  //     } = institution;
  //     const searchLowerCase = search.toLowerCase();
  //
  //     let stringTags = "";
  //
  //     if (tags !== null) {
  //       stringTags = tags?.map(e => e.label + "")?.join(" ");
  //     }
  //
  //     const hasSearchMatch = [
  //       name,
  //       type,
  //       secondName === null ? "" : secondName,
  //       stringTags,
  //       mainType,
  //       interventionLocation,
  //     ]
  //       .filter(e => e !== null || e !== undefined)
  //       .some(field => field.toLowerCase().includes(searchLowerCase));
  //
  //     return search.length === 0 || hasSearchMatch;
  //   });
  //
  // let copyInstitutions = searchFilterData();

  return (
    <Content>
      <Typography.Title level={2} className={""}>
        Logs
      </Typography.Title>
      <AlignCenterEnd>
        <CustomForm
          style={{
            flex: 1,
            maxWidth: 1200,
            paddingRight: 20,
          }}
          dataSource={inputsLogsList({
            searchState,
            pagination,
            loading,
            defaultPagination,
            setPagination,
            dispatchActionLogs,
            setSearchState,
            formRef,
          })}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          handleSubmit={handleSubmit}
          // onValuesChange={onValuesChange}
        />
      </AlignCenterEnd>
      <CustomTable
        onRowLink={record => {
          return routes.logs(record._id).detail.path;
        }}
        emptyText={
          <>
            <p>Aucun log</p>
          </>
        }
        loading={loading}
        dataSource={logs}
        columns={columnsLogList(logs)}
        rowKey="_id"
        pagination={{
          hideOnSinglePage: false,
          position: ["topRight"],
          defaultPageSize: pagination.pageSize,
          pageSizeOptions: [10, 20, 50, 100, 250],
          showSizeChanger: true,
          current: pagination.currentPage,
          total: totals,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} sur ${total} logs`,
        }}
        onChange={async (p, filters, sorter, extra) => {
          let extraSorter = {};

          if (sorter.order !== undefined) {
            extraSorter = {
              sorter: {
                key: sorter.columnKey,
                order: sorter.order,
              },
            };
          } else {
            extraSorter = {
              sorter: defaultPagination.sorter,
            };
          }

          setPagination({
            currentPage: p.current,
            pageSize: p.pageSize,
            ...extraSorter,
          });
        }}
      />
    </Content>
  );
}
